<div class="toolbar">
  <div class="field">
    <app-business-partner-selector (businessPartnerChange)="onBusinessPartnerChange($event)"></app-business-partner-selector>
  </div>
  <div class="field">
    <app-provider-selector
      [businessPartnerId]="selectedBusinessPartnerId"
      (providerChange)="onProviderChange($event)">
    </app-provider-selector>
  </div>
  <div class="field carrier" *ngIf="blockedReason === null">
    <app-carrier-selector
      [carriers]="(enabledCarriers$ | async) || []"
      [resetToken]="carrierResetToken"
      (onCarrierChanged)="onCarrierSelected($event)">
    </app-carrier-selector>
  </div>
  <div class="search" *ngIf="blockedReason === null && selectedCarrierApiKey">
    <span class="icon" aria-hidden="true"></span>
    <input type="text" [placeholder]="'drivers.search_placeholder' | translate" [ngModel]="searchTerm" (ngModelChange)="onSearchChange($event)" />
    <button
      class="clear"
      *ngIf="searchTerm"
      type="button"
      aria-label="Clear search"
      title="Clear search"
      (click)="clearSearch()">
      &times;
    </button>
  </div>
  <label class="checkbox" *ngIf="blockedReason === null && selectedCarrierApiKey">
    <input type="checkbox" [ngModel]="showDisabled" (ngModelChange)="onShowDisabledChange($event)" />
    <span>{{ 'drivers.show_disabled' | translate }}</span>
  </label>
</div>

<div *ngIf="blockedReason !== null" class="drivers-blocked">
  {{ getBlockedMessageKey() | translate }}
</div>

<ng-container *ngIf="blockedReason === null && selectedCarrierApiKey">
  <div *ngIf="driversLoading" class="drivers-loading">
    <div class="spinner" aria-hidden="true"></div>
    <span>{{ 'drivers.loading_drivers' | translate }}</span>
  </div>
  <div *ngIf="!driversLoading && driversError" class="error">{{ driversError }}</div>
  <ng-container *ngIf="!driversLoading && !driversError">
    <ng-container *ngIf="(filteredDrivers$ | async) as drivers">
      <div class="empty" *ngIf="drivers.length === 0">{{ 'drivers.no_drivers' | translate }}</div>
      <table class="drivers-table" *ngIf="drivers.length > 0">
        <thead>
          <tr>
            <th class="sortable"
                (click)="onSort('HOSUserName')"
                [attr.aria-sort]="sortKey==='HOSUserName' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'drivers.username' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='HOSUserName' && sortDir==='asc'" [class.desc]="sortKey==='HOSUserName' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('HOSDriverId')"
                [attr.aria-sort]="sortKey==='HOSDriverId' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'drivers.hos_driver_id' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='HOSDriverId' && sortDir==='asc'" [class.desc]="sortKey==='HOSDriverId' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('Name')"
                [attr.aria-sort]="sortKey==='Name' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'drivers.name' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='Name' && sortDir==='asc'" [class.desc]="sortKey==='Name' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('LastName')"
                [attr.aria-sort]="sortKey==='LastName' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'drivers.last_name' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='LastName' && sortDir==='asc'" [class.desc]="sortKey==='LastName' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                *ngIf="!isAzugaProvider()"
                (click)="onSort('LicenseNumber')"
                [attr.aria-sort]="sortKey==='LicenseNumber' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'drivers.license_number' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='LicenseNumber' && sortDir==='asc'" [class.desc]="sortKey==='LicenseNumber' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable"
                (click)="onSort('CopilotEnabled')"
                [attr.aria-sort]="sortKey==='CopilotEnabled' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content">
                <span>{{ 'drivers.enabled' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='CopilotEnabled' && sortDir==='asc'" [class.desc]="sortKey==='CopilotEnabled' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable notifications-header"
                *ngIf="isMondoProvider() || isAzugaProvider()"
                (click)="onSort('Notifications')"
                [attr.aria-sort]="sortKey==='Notifications' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content centered">
                <span>{{ 'drivers.notifications' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='Notifications' && sortDir==='asc'" [class.desc]="sortKey==='Notifications' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable platform-header"
                (click)="onSort('Platform')"
                [attr.aria-sort]="sortKey==='Platform' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content centered">
                <span>{{ 'drivers.platform' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='Platform' && sortDir==='asc'" [class.desc]="sortKey==='Platform' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="sortable truck-id-header"
                *ngIf="isMondoProvider() || isAzugaProvider()"
                (click)="onSort('TruckId')"
                [attr.aria-sort]="sortKey==='TruckId' ? (sortDir==='asc' ? 'ascending' : 'descending') : 'none'">
              <span class="header-content centered">
                <span>{{ 'drivers.truck_id' | translate }}</span>
                <span class="sort-indicator" [class.asc]="sortKey==='TruckId' && sortDir==='asc'" [class.desc]="sortKey==='TruckId' && sortDir==='desc'"></span>
              </span>
            </th>
            <th class="actions-header">
              <span class="header-content centered">
                <span>{{ 'drivers.actions' | translate }}</span>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let d of drivers">
            <td>{{ d.HOSUserName }}</td>
            <td>{{ d.HOSDriverId || '-' }}</td>
            <td>{{ d.Name }}</td>
            <td>{{ d.LastName }}</td>
            <td *ngIf="!isAzugaProvider()">{{ d.LicenseNumber || '-' }}</td>
            <td>
              <label class="switch" *ngIf="!isAzugaProvider() || shouldShowAzugaToggle(d)">
                <input type="checkbox" [checked]="(d.CopilotEnabled + '') === '1' || d.CopilotEnabled === true" [disabled]="isAzugaProvider() && isAzugaDriverToggling(d)" (change)="toggleDriver(d)">
                <span class="slider"></span>
              </label>
            </td>
            <td class="notifications-cell" *ngIf="isMondoProvider() || isAzugaProvider()">
              <ng-container *ngIf="isDriverEnabled(d)">
                <span class="notifications-content">
                  <span *ngIf="shouldShowNotificationsSpinner(d, drivers.length)" class="notifications-spinner" aria-hidden="true"></span>
                  <span *ngIf="!shouldShowNotificationsSpinner(d, drivers.length) && shouldShowNotificationsApiError(d)" class="notifications-text api-error">
                    {{ 'drivers.notifications_api_error' | translate }}
                  </span>
                  <ng-container *ngIf="!shouldShowNotificationsSpinner(d, drivers.length) && !shouldShowNotificationsApiError(d) && getNotificationsIcon(d) as notificationIcon">
                    <span
                      class="notification-indicator"
                      tabindex="0"
                      [attr.title]="getNotificationsTooltip(d)"
                      [attr.aria-label]="getNotificationsAriaLabel(d)">
                      <span
                        class="material-symbols-outlined notification-icon"
                        [class.available]="getNotificationsClass(d) === 'available'"
                        [class.unavailable]="getNotificationsClass(d) === 'unavailable'"
                        [class.unopened-app]="getNotificationsClass(d) === 'unopened-app'">
                        {{ notificationIcon }}
                      </span>
                    </span>
                  </ng-container>
                </span>
              </ng-container>
            </td>
            <td class="platform-cell">
              <ng-container *ngIf="isDriverEnabled(d)">
                <span
                  class="platform-content"
                  [class.platform-latest]="getPlatformStatusClass(d) === 'platform-latest'"
                  [class.platform-supported]="getPlatformStatusClass(d) === 'platform-supported'"
                  [class.platform-unsupported]="getPlatformStatusClass(d) === 'platform-unsupported'"
                  [class.platform-unknown]="getPlatformStatusClass(d) === 'platform-unknown'"
                  [attr.title]="getPlatformTooltip(d)"
                  [attr.tabindex]="hasPlatformTooltip(d) ? '0' : null"
                  [attr.aria-label]="getPlatformAriaLabel(d)">
                  <span *ngIf="getPlatformIcon(d) as platformIcon"
                    class="platform-icon"
                    [class.android]="platformIcon === 'android'"
                    [class.ios]="platformIcon === 'ios'"
                    aria-hidden="true"></span>
                  <span class="platform-version">{{ getPlatformVersion(d) }}</span>
                </span>
              </ng-container>
            </td>
            <td class="truck-id-cell" *ngIf="isMondoProvider() || isAzugaProvider()">
              <ng-container *ngIf="isDriverEnabled(d)">
                <span class="truck-id-content">
                  <span *ngIf="shouldShowTruckIdSpinner(d, drivers.length)" class="truck-id-spinner" aria-hidden="true"></span>
                  <span *ngIf="!shouldShowTruckIdSpinner(d, drivers.length) && shouldShowTruckIdApiError(d)" class="truck-id-text api-error">
                    {{ 'drivers.truck_id_api_error' | translate }}
                  </span>
                  <span *ngIf="!shouldShowTruckIdSpinner(d, drivers.length) && !shouldShowTruckIdApiError(d)" class="truck-id-text" [class.available]="hasDriverTruckId(d)" [class.unavailable]="!hasDriverTruckId(d)">
                    {{ getDriverTruckId(d) || ('drivers.no_truck_id' | translate) }}
                  </span>
                </span>
              </ng-container>
            </td>
            <td>
              <button class="icon-button" type="button"
                *ngIf="shouldShowAzugaAddAction(d)"
                [attr.title]="'drivers.azuga_add_driver_action' | translate"
                [attr.aria-label]="'drivers.azuga_add_driver_action' | translate"
                (click)="openAddAzugaDriverDialog(d)">
                <span class="material-symbols-outlined" aria-hidden="true">add</span>
              </button>
              <button class="icon-button" type="button"
                *ngIf="shouldShowSharedPasswordAction(d)"
                (click)="openPasswordDialog(d)">
                <span class="material-symbols-outlined" aria-label="change password">key</span>
              </button>
              <button class="icon-button" type="button"
                *ngIf="shouldShowSharedEditAction(d)"
                (click)="openClearFlagsDialog(d)">
                <span class="material-symbols-outlined" [attr.aria-label]="'drivers.edit_driver_data_action_aria' | translate">edit</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>
</ng-container>

<!-- Reset Log Pointer Dialog -->
<app-reset-log-pointer-dialog *ngIf="showResetDialog"
  [name]="dialogTarget?.Name || ''"
  [lastName]="dialogTarget?.LastName || ''"
  [submitting]="resetSubmitting"
  (closed)="closeResetDialog()"
  (submit)="onResetSubmit($event)" />

<!-- Set Driver Password Dialog -->
<app-set-driver-password-dialog *ngIf="showPasswordDialog"
  [username]="dialogTarget?.HOSUserName || ''"
  [submitting]="passwordSubmitting"
  (closed)="closePasswordDialog()"
  (submit)="onPasswordSubmit($event)" />

<!-- Clear Driver Flags Dialog -->
<app-clear-driver-flags-dialog *ngIf="showClearFlagsDialog"
  [username]="dialogTarget?.HOSUserName || ''"
  [truckId]="getDialogTruckId()"
  [submitting]="clearFlagsSubmitting"
  (closed)="closeClearFlagsDialog()"
  (submit)="onClearFlagsSubmit($event)" />

<!-- Add Azuga Driver Dialog -->
<app-add-azuga-driver-dialog *ngIf="showAddAzugaDriverDialog"
  [driverAlias]="addAzugaDriverTarget?.HOSUserName || ''"
  [driverName]="(((addAzugaDriverTarget?.Name || '') + ' ' + (addAzugaDriverTarget?.LastName || '')).trim())"
  [submitting]="addAzugaDriverSubmitting"
  (closed)="closeAddAzugaDriverDialog()"
  (submit)="onAddAzugaDriverSubmit($event)" />
